import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4w78fajgal: FaireBrandEntity = {
  token: "b_4w78fajgal",
  type: "brand",
  name: "Meraki Gemstones",
  avatarUrl:
    "https://cdn.faire.com/fastly/9471b3d505ad8c6e1b203bebf288bf2f2a8f00f83386a1b243b273a1dec553cc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/65cd7cedaca4da4b0d955d3fac36b0a3a9a40c2a583870cab664eda1ce6bcda7.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/9471b3d505ad8c6e1b203bebf288bf2f2a8f00f83386a1b243b273a1dec553cc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/65cd7cedaca4da4b0d955d3fac36b0a3a9a40c2a583870cab664eda1ce6bcda7.webp",
  location: "Neenah, WI, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 705,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a wholesaler & Manufacturer of Gemstone products, Metaphysical Tools, Crystals located in Neenah, Wisconsin. We believe in providing quality products at great prices with total focus on great customer experience.  \n\n\nWe source our products from over 70 different countries including Madagascar, Indonesia, Peru, Pakistan, Russia, India, China, etc. We also carry a wide variety of tumbled stones; small, medium, large, hearts, spheres, pillow and worry stones. Recently we have added Palo Santo wood, incense, oil, Petrified Wood and Malachite to our product line.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:47.457Z",
    importedBy: "entity-db-cli",
  },
};
